export default {
  // 步驟一
  step1: {
    text: "第一步：在釘釘群",
    settings: "設置",
    text2: "浮窗，選擇",
    addRobot: "添加機器人",
    text3: "，選擇",
    custom: "自定義",
    text4: "機器人",
  },

  // 步驟二
  step2: {
    text: "第二步：點擊確認添加",
    robot: "機器人",
    text2: "安全設置選項勾選",
    signatureVerification: "簽名校驗",
    text3: "，點擊確認釘釘群機器人配置完成",
  },

  // 步驟三
  step3: {
    text: "第三步：點擊完成添加",
    robot: "機器人",
    text2:
      "成功之後，在群設置->群機器人找到該機器人點開信息，可複製釘釘機器人webhook和簽名校驗",
  },

  // 步驟四
  step4: {
    text: "第四步：將複製的釘釘機器人標籤密鑰和釘釘機器人Webhook粘貼到地址監控釘釘對應選項",
  },
};
